import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-account\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 170.666667a170.666667 170.666667 0 0 1 170.666667 170.666666 170.666667 170.666667 0 0 1-170.666667 170.666667 170.666667 170.666667 0 0 1-170.666667-170.666667 170.666667 170.666667 0 0 1 170.666667-170.666666m0 426.666666c188.586667 0 341.333333 76.373333 341.333333 170.666667v85.333333H170.666667v-85.333333c0-94.293333 152.746667-170.666667 341.333333-170.666667z\" fill=\"\" p-id=\"18513\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol